import { PageHeader } from "../../components/pages/page-header/PageHeader";
import { MyH1 } from "../../components/UI/my-h1/MyH1";
import { Container } from "../../components/UI/container/Container";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { isPhone } from "../../constants/env";
import { Fragment } from "react";
import { MyHead } from "../../components/pages/MyHead";
import { Footer } from "../../components/pages/homepage/footer/Footer";

// @ts-ignore
export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
      // Will be passed to the page component as props
    },
  };
}

function ContactPage() {
  const { t } = useTranslation("common");

  return (
    <Fragment>
      <MyHead title={t("contacts")} description={t("contacts")} />
      <PageHeader>
        <MyH1
          size={isPhone ? "2.5rem" : "3rem"}
          color="white"
          className="text-center"
        >
          {t("contacts")}
        </MyH1>
      </PageHeader>
      <Container noHeight>
        <div
          style={{ minHeight: "calc(100vh - 541px)" }}
          className="flex items-center"
        >
          <iframe
            frameBorder={0}
            className="w-full h-[60vh] mb-4"
            src="https://maps.google.com/maps?q=psiworks%2C%20Lisboa%2C%20Portugal&#038;t=m&#038;z=14&#038;output=embed&#038;iwloc=near"
            title="Psiworks, Lisboa, Portugal"
            aria-label="Psiworks, Lisboa, Portugal"
          />
          {/*<Address />*/}
        </div>
      </Container>
      <Footer isVisible />
    </Fragment>
  );
}

export default ContactPage;
